<!--切换语言使用的组件-->
<template>
	<div :class="{ChangeLanguage:true, open:isOpen}" >
		<div class="dropdown"  @click="isOpen=!isOpen">
			<span class="select-value">{{selectValue}}</span>
		</div>
		<ul class="dropdown-toggle">
			<li v-for="item in langMap"
				:key="item.value"
				@click="languageChangeHandle(item.value,item.label)"
				@mouseenter="isOpen=true" @mouseout="isOpen=false"
				:class="selectValue===item.label?'selected':''"
			>{{item.label}}</li>
		</ul>
	</div>
</template>
<script>
	import langMap from '@/constant/i18n';
	import { dynamicImportLang } from '@/utils/dynamicImport';
	export default {
		name:'Layout',
		data(){
			const locale = this.$i18n.locale;
			const lang = langMap.find(item => item.value === locale);
			return {
				lang:locale,
				langMap,
				selectValue:lang.label,
				isOpen:false
			};
		},
		methods:{
			/**
			 * 国际化在切换语言的时候，是否需要reload页面，自行判断
			 */
			languageChangeHandle(lang,label){
				this.lang = lang;
				this.selectValue = label;
				this.isOpen = false;
				// window.location.reload();
			}
		},
		watch:{
			lang(lang){
				/**
				 * 对语言包进行按需加载
				 */
				dynamicImportLang(this.$i18n,lang).then(() => {
					this.$i18n.locale = lang;
				});
			}
		}
	};
</script>

<style lang="scss" scoped>
	$hoverColor: rgba(250, 250, 250, .2);
	.ChangeLanguage{
		margin: 10px;
		font-size: 14px;
		font-weight: 700;
		cursor: pointer;
		.open{
			display: block;
		}

		.dropdown{
			position: relative;
			width: 100px;
			border: 1px solid #fff;
			line-height: 40px;
			border-radius: 8px;
			.arrow{
			}
		}
		.dropdown-toggle{
			position: relative;
			border-right: 1px solid #fff;
			border-bottom: 1px solid #fff;
			border-left: 1px solid #fff;
			background: rgba(0, 0, 0, .4);
			display: none;
			border-radius: 0 0 8px 8px;
			li{
				line-height: 40px;
			}
			li:hover{
				background: $hoverColor;
			}
		}
	}
	.open{
		.dropdown-toggle{
			display: block;
			cursor: pointer;
		}
		.dropdown{
			border-radius: 8px  8px 0 0 ;
			border-bottom: 0;
		}
	}
</style>
